var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from '@mui/material/styles';
export var typography = {
    fontFamily: [
        'Montserrat',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
    ].join(','),
    h1: {
        fontSize: '2rem',
        fontWeight: 700,
        lineHeight: '3rem'
    },
    h2: {
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: '2.25rem'
    },
    h3: {
        fontSize: '1.25rem',
        fontWeight: 700,
        lineHeight: '2rem'
    },
    subtitle1: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: '1.5rem'
    },
    subtitle2: {
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: '1.25rem'
    },
    body1: {
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.5rem'
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.25rem'
    },
    caption1: {
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: '1rem'
    },
    caption2: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: '1rem'
    },
    overline1: {
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: '0.75rem'
    },
    overline2: {
        fontSize: '0.625rem',
        fontWeight: 600,
        lineHeight: '0.75rem'
    },
    caption: undefined,
    overline: undefined,
    h4: undefined,
    h5: undefined,
    h6: undefined
};
export var palette = {
    primary: {
        main: '#443EFF',
        100: '#E3E2FF',
        200: '#BEBBFF',
        300: '#9895FF',
        400: '#736EFF',
        500: '#443EFF',
        600: '#332EBF',
        700: '#25228C',
        800: '#1B1D6A',
        900: '#0A0926',
        50: '#F3F3FF'
    },
    secondary: {
        main: '#ED811E',
        100: '#FCECDD',
        200: '#F9D3B0',
        300: '#F5BA83',
        400: '#F2A156',
        500: '#ED811E',
        600: '#B26116',
        700: '#824710',
        800: '#532D0A',
        900: '#241304'
    },
    grey: {
        100: '#F5F5F5',
        200: '#E8E8E8',
        300: '#DBDBDB',
        400: '#CDCDCD',
        500: '#BDBDBD',
        600: '#8E8E8E',
        700: '#686868',
        800: '#424242',
        900: '#1C1C1C'
    },
    error: {
        100: '#F5E2E2',
        200: '#E7BABA',
        300: '#D99393',
        400: '#CB6C6C',
        500: '#BA3B3B',
        600: '#8B2C2C',
        700: '#662020',
        800: '#411515',
        900: '#1C0909'
    }
};
export var components = {
    MuiAutocomplete: {
        styleOverrides: {
            option: function (_a) {
                var theme = _a.theme, ownerState = _a.ownerState;
                return __assign({ '&[aria-selected="true"]': {
                        backgroundColor: "".concat(theme.palette.primary['100'], " !important"),
                        '&:hover': {
                            backgroundColor: "".concat(theme.palette.primary['100'], " !important")
                        }
                    }, '&:hover': {
                        backgroundColor: "".concat(theme.palette.primary['50'], " !important")
                    }, backgroundColor: '#fff !important' }, typography.body1);
            },
            paper: function (_a) {
                var _b;
                var theme = _a.theme, ownerState = _a.ownerState;
                var disableBorder = (ownerState === null || ownerState === void 0 ? void 0 : ownerState.freeSolo) && ((_b = ownerState === null || ownerState === void 0 ? void 0 : ownerState.options) === null || _b === void 0 ? void 0 : _b.length) === 0 && (ownerState === null || ownerState === void 0 ? void 0 : ownerState.loading) === false;
                return {
                    border: disableBorder ? 'none' : "1px solid ".concat(theme.palette.grey['600']),
                    borderRadius: '4px',
                    marginTop: '4px',
                    marginBottom: '4px'
                };
            }
        },
        defaultProps: { size: 'small' }
    },
    MuiInputBase: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return ({
                    '& input': typography.body1,
                    '&.Mui-disabled': { backgroundColor: theme.palette.grey['100'] }
                });
            }
        }
    },
    MuiButton: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return ({
                    textTransform: 'none'
                });
            }
        },
        defaultProps: { disableElevation: true }
    },
    MuiFormControlLabel: {
        styleOverrides: { label: __assign(__assign({}, typography.subtitle1), { textTransform: 'none' }) }
    },
    MuiFormHelperText: { styleOverrides: { root: __assign(__assign({}, typography.caption1), { marginLeft: 0 }) } },
    MuiSlider: {
        styleOverrides: {
            rail: { backgroundColor: '#DBDBDB' },
            thumbColorPrimary: { backgroundColor: 'white', border: '1px solid #DBDBDB' },
            valueLabel: function (_a) {
                var theme = _a.theme;
                return ({
                    backgroundColor: theme.palette.primary[500],
                    padding: theme.spacing(0.5),
                    borderRadius: '15%',
                    '::before': { display: 'none' }
                });
            }
        }
    }
};
export default createTheme({ typography: typography, palette: palette, components: components });
//# sourceMappingURL=index.js.map